import { Menu } from '@headlessui/react'
import i18next from 'i18next'
import Image from 'next/image'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { LANGS } from '../../../constants/i18n'
import { classNames } from '../../../functions'
import { useDebounce } from '../../../hooks/utils'
import { updateLanguage } from '../../../state/application/actions'
import { useLanguage } from '../../../state/application/hooks'
import { AnimationTransition } from '../../Animation'

/**
 *
 * @return {JSX.Element}
 */
export default function LanguageSwitch() {
  const dispatch = useDispatch()
  const locale = useLanguage()
  const [debouncedHover, setDebouncedHover] = useState(false)
  const [hover, setHover] = useState(false)
  const DebouncedHover = useDebounce([debouncedHover, hover], 200)

  useEffect(() => {
    const [debouncedHover] = DebouncedHover
    setHover(debouncedHover)
  }, [DebouncedHover])
  return (
    <Menu
      onMouseEnter={() => {
        setHover(true)
        setDebouncedHover(true)
      }}
      onMouseLeave={() => setDebouncedHover(false)}
      as="div"
      className="relative group"
    >
      <>
        <Menu.Button className="grid p-1 text-sm font-bold duration-500 ease-in-out rounded-lg shadow-sm group-hover:bg-polling bg-buttonbg align-center text-primary hover:bg-hovered focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-transparent focus:ring-transparent">
          <Image src={LANGS[locale].flag} alt="lang" width={25} height={25} />
        </Menu.Button>
        <AnimationTransition show={hover}>
          <Menu.Items
            as="div"
            className="overflow-hidden -left-[53.5px] absolute group min-w-[140px] mt-2.5 origin-top-right z-50 px-2 py-2 gap-x-4 w-fit border border-orange-500 rounded-lg shadow-lg  ring-1 ring-opacity-5 focus:outline-none"
          >
            {Object.keys(LANGS)?.map((locale) => {
              const { code, name, flag } = LANGS[locale]
              return (
                <Menu.Item as="div" key={code} className="z-50 grid">
                  <Menu.Button
                    onClick={() => {
                      i18next.changeLanguage(code)
                      dispatch(updateLanguage({ language: locale }))
                      setHover(false)
                      setDebouncedHover(false)
                    }}
                    as="div"
                    key={code}
                    className={classNames(
                      i18next.language === code ? 'bg-gray-300' : '',
                      'z-50 hover:opacity-80 rounded-lg min-w-full cursor-pointer h-[40px] text-sm hover:bg-gray-500 group flex items-center w-full gap-2 px-2 text-primary'
                    )}
                  >
                    <Image
                      className="z-50 inline align-middle"
                      src={flag}
                      width={20}
                      height={20}
                      alt={name}
                      aria-hidden="true"
                    />
                    <span className="z-50 mx-2 text-xs font-normal tracking-wide text-pollingactive">
                      {name}
                    </span>
                  </Menu.Button>
                </Menu.Item>
              )
            })}
            <div className="top-0 left-0 custom-backdrop-blur z-1" />
          </Menu.Items>
        </AnimationTransition>
      </>
    </Menu>
  )
}
